import React from 'react';
import type { ReactNode } from 'react';
interface ContainerProps {
  children: ReactNode;
  className?: string;
}
export function Container({
  children,
  className = ''
}: ContainerProps) {
  return <div className={`mx-auto w-full max-w-container px-6 md:px-10 ${className}`} data-id="element-385" data-mp="3bj4cqy7xj0ke">{children}</div>;
}